import { useQuery } from '@tanstack/vue-query';
import { QueryKey } from '@/api/common/types/query-key.enum';
import { getRecoverableWorkout } from '../workout.api';
import { computed, type Ref } from 'vue';

export const useRecoverableWorkout = (enabled: Ref<boolean> | { value: boolean }) => {
  return useQuery({
    queryKey: [QueryKey.GetRecoverableWorkout],
    queryFn: getRecoverableWorkout,
    enabled: computed(() => !!enabled.value),
    staleTime: 30_000,
    retry: false,
  });
};
